<template>
  <!--  -->
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
    <!--  -->
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <!--  -->
      <div class="text-center flex justify-between">
        <!--  -->
        <h6 class="text-gray-800 text-xl font-bold">
          {{ $t('settings') }}
        </h6>
        <!--  -->

        <!--  -->
        <button class="rouanded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600 hover:shadow-inner hover:bg-green-700 transition-all duration-300" type="button" @click="save">
          Save settings
        </button>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <div v-if="currentUser.type && currentUser.type !== 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <!--  -->
      <loading v-model:active="loading" :is-full-page="fullPage" />
      <!--  -->
      
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('order_fees') }}
      </h6>
      <!--  -->
      
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              {{ $t('confirmation_fees') }} <sup>({{ currency }})</sup>
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.order.feesConfirmation" type="number" min="0":disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="fulfillement_fees">
              <!--  -->
              {{ $t('fulfillement_fees') }} <sup>({{ currency }})</sup>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.order.fulfillement_fees" type="number" min="0":disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="fulfillement_fees">
              <!--  -->
              {{ $t('upsell fees')}} <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.order.upsell_fees" type="number" min="0":disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="fulfillement_fees">
              <!--  -->
              {{ $t('is confirmed fees')}} <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.order.is_confirmed_fees" type="number" min="0" class="bg-white px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('shipping_fees') }}
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              <!--  -->
              {{ $t('Default shipping fees') }}
              <!--  -->
              <sup>({{ currency }})</sup>
              <!--  -->
            </label>
            <!--  -->
            
            <!--  -->
            <input v-model="formData.detail.shipping.fees" type="number" min="0" :disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
            
            <!--  -->
            <label class="mt-3 block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              {{ $t('shipping_fees') }} <sup>({{ currency }})</sup>
            </label>
            <!--  -->

            <!--  -->
            <div :disabled="!activeAllFees" :class="{ 'bg-gray-200 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="shadow-md rounded-lg px-3 py-2 mb-4 overflow-y-auto max-height-300">
              <!--  -->
              <div class="accordion">
                <!--  -->
                <div v-for="(zon, index) in cities" :key="index" class="accordion-item">
                  <!--  -->
                  <button :id="`accordion-button-${index}`" :aria-expanded="`${zon.display}`" @click="Show(index, zon.display)">
                    <!--  -->
                    <span class="accordion-title">{{ zon._id.name }} ({{ zon._id.price }}
                      <!--  -->
                      <span v-if="idWharhouse">{{ idWharhouse.currency }}</span>)
                      <!--  -->
                    </span>
                    <!--  -->
                    
                    <!--  -->
                    <span class="icon" aria-hidden="true" />
                    <!--  -->
                  </button>
                  <!--  -->

                  <!--  -->
                  <div v-if="zon.display" class="accordion-content w-full inline-block border-dotted border-4 border-light-orange-500 justify-start cursor-pointer text-gray-700 hover:text-orange-400 hover:bg-orange-100 rounded-md mb-2">
                    <!--  -->
                    <span v-for="(city, ind) in zon._id.cities" :key="ind" class="tags-block">{{ city }}</span>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              {{ $t('return_fees') }} <sup>({{ currency }})</sup>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.shipping.refund" type="number" min="0" :disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{$t('cancelation_fees') }} <sup>({{ currency }})</sup></label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.shipping.cancelation" type="number" min="0" :disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('Cashflow Shipping Fees') }}
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-col gap-4">
        <!--  -->
        <div class="flex items-end justify-center px-2">
          <!--  -->
          <div class="w-full lg:w-1/4 px-2">
            <!--  -->
            <div class="relative w-full">
              <!--  -->
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
                {{ $t('Default City Fees') }} <sup>({{ currency }})</sup>
              </label>
              <!--  -->

              <!--  -->
              <input v-model="formData.detail.defaultCityFees" type="number" min="0" class="px-3 py-3 bg-white placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full lg:w-1/4 px-2">
            <!--  -->
            <div class="relative w-full">
              <!--  -->
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
                {{ $t('City Name') }} <sup>({{ currency }})</sup>
              </label>
              <!--  -->

              <!--  -->
              <input v-model="newCity.cityName" type="text" placeholder="City Name" class="px-3 py-3 bg-white placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full lg:w-1/4 px-2">
            <!--  -->
            <div class="relative w-full">
              <!--  -->
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
                {{ $t('City Fees') }} <sup>({{ currency }})</sup>
              </label>
              <!--  -->

              <!--  -->
              <input v-model="newCity.cityFees" type="number" min="0" class="px-3 py-3 bg-white placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full lg:w-1/4 px-2">
            <!--  -->
            <button @click="addCity" class="w-full px-3 py-3 bg-orange-500 text-white rounded text-sm hover:bg-orange-600 focus:outline-none" >
              {{ $t('Add City') }}
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="flex flex-col">
          <!--  -->
          <label class="mt-3 block uppercase text-gray-700 text-xs font-bold px-4 mb-2">
            <!--  -->
            {{ $t('Cities and Shipping Fees') }}
            <!--  -->

            <!--  -->
            <sup>({{ currency }})</sup>
            <!--  -->
          </label>
          <!--  -->

          <!--  -->
          <div class="flex items-center flex-wrap px-2">
            <!--  -->
            <div class="w-full lg:w-1/4 p-2" v-for="(city, index) in formData.detail.cities" :key="index">
              <!--  -->
              <div class="flex items-center justify-between bg-white px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline ease-linear transition-all duration-150">
                <!--  -->
                <span class="text-sm font-bold">
                  {{ city.cityName }} ({{ city.cityFees }} {{ currency }})
                </span>
                <!--  -->

                <!--  -->
                <button @click="removeCity(index)" class="text-red-500 hover:text-red-700 focus:outline-none" >
                  <!--  -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <!--  -->
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                    <!--  -->

                    <!--  -->
                    <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    <!--  -->
                  </svg>
                  <!--  -->
                </button>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('quality_control') }}
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              {{$t('quality_control') }} <sup>({{ currency }})</sup>
            </label>
            <!--  -->

            <!--  -->
            <input v-model="formData.detail.quality_control" type="number" min="0" :disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">TVA</h6>
      <!--  -->
      
      <!--  -->
      <div class="w-full lg:w-4/12 px-4">
        <!--  -->
        <div class="relative w-full mb-3">
          <!--  -->
          <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">TVA</label>
          <!--  -->

          <!--  -->
          <div class="flex flex-wrap items-stretch w-full relative bg-white rounded mb-4 shadow">
            <!--  -->
            <input v-model="formData.detail.tva" type="number" :disabled="!activeAllFees" :class="{ 'bg-gray-300 cursor-not-allowed opacity-50': !activeAllFees, 'bg-white': activeAllFees }" class="flex-shrink flex-grow leading-normal w-px flex-1 border-0 h-10 px-3 py-3 relative self-center font-roboto text-sm placeholder-gray-400 text-gray-700 outline-none" min="0" />
            <!--  -->

            <!--  -->
            <div class="flex -mr-px">
              <!--  -->
              <span class="flex items-center leading-normal bg-white rounded rounded-l-none border-0 px-3 whitespace-no-wrap text-gray-600">%</span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('global_fees') }}</h6>
      <!--  -->
      
      <!--  -->
      <div class="w-full lg:w-4/12 px-4">
        <!--  -->
        <div class="relative w-full mb-3">
          <!--  -->
          <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t('global_fees') }} <sup>({{ currency }})</sup></label>
          <!--  -->

          <!--  -->
          <input type="number" min="0" v-model="formData.detail.global_fees" @input="onGlobalFeesChange" class="bg-white px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('phone') }}
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">
              {{ $t('phone') }}
            </label>
            <!--  -->
            
            <!--  -->
            <input v-model="formData.detail.phone" type="text" class="bg-white px-3 py-3 placeholder-gray-400 text-gray-700 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"/>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
    
    <!--  -->
    <div v-if="currentUser.type && currentUser.type === 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <!--  -->
      <loading v-model:active="loading" :is-full-page="fullPage" />
      <!--  -->
      
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('API') }}
      </h6>
      <!--  -->
      
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full md:w-1/2 xl:w-1/2 px-4">
          <!--  -->
          <div class="ant-col">
            <!--  -->
            <div class="ant-row">
              <!--  -->
              
              <!--  -->
              <div class="ant-label">
                <!--  -->
                <label for="key" class="ant-form" title="identité du client">API key</label>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="ant-col ant-form-item">
                <!--  -->
                <div class="ant-form-item-control has-success">
                  <!--  -->
                  <span class="ant-form-item-children">
                    <!--  -->
                    <span class="ant-input-group-wrapper">
                      <!--  -->
                      <span class="ant-input-group">
                        <!--  -->
                        <input id="key" disabled="" class="ant-input ant-input-disabled" type="text" :value="currentUser.api ? currentUser.api.key : ''" />
                        <!--  -->
                        
                        <!--  -->
                        <span class="ant-input-group-addon" @click="copyIt('key')">
                          <!--  -->
                          <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0 hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166">
                            <!--  -->
                            <path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z" />
                            <!--  -->
                          </svg>
                          <!--  -->
                        </span>
                        <!--  -->
                      </span>
                      <!--  -->
                    </span>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full md:w-1/2 xl:w-1/2 px-4">
          <!--  -->
          <div class="ant-col">
            <!--  -->
            <div class="ant-row">
              <!--  -->
              <div class="ant-label">
                <!--  -->
                <label for="secret" class="ant-form" title="identité du client">API secret key</label>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="ant-col ant-form-item">
                <!--  -->
                <div class="ant-form-item-control has-success">
                  <!--  -->
                  <span class="ant-form-item-children">
                    <!--  -->
                    <span class="ant-input-group-wrapper">
                      <!--  -->
                      <span class="ant-input-group" @click="copyIt('secret')"><input id="secret" disabled="" class="ant-input ant-input-disabled" type="text" :value="currentUser.api ? currentUser.api.secret : ''" />
                        <!--  -->
                        <span class="ant-input-group-addon">
                          <!--  -->
                          <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0 hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166">
                            <!--  -->
                            <path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z" />
                            <!--  -->
                          </svg>
                          <!--  -->
                        </span>
                        <!--  -->
                      </span>
                      <!--  -->
                    </span>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('Warehouses') }} (Country code)
      </h6>
      <!--  -->
      
      <!--  -->
      <div class="container tag-rail">
        <!--  -->
        <div class="rail-container">
          <!--  -->
          <div id="rail" class="rail">
            <!--  -->
            <span v-for="(item, index) in currentUser.countries" :id="`tag${index}`" :key="index" class="tag">
              {{ $f.getCountryNameByCode(options, item) }} ({{ item }})
            </span>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        Prefix Order ID
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div v-for="item in currentUser.prefixs" :key="item.country" class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="border hover:border-orange-500  hover:border-orange-500  focus-within:border-orange-500 flex flex-wrap items-stretch w-full mb-2 relative h-15 bg-white items-center rounded">
            <!--  -->
            
            <div class="flex -mr-px justify-center p-1 pr-0">
              <!--  -->
              <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                <!--  -->
                <span class="select-none mr-2">
                  <!--  -->
                  <img class="flag-img" :src="$f.getCountryCode(item.country)" />
                  <!--  -->
                </span>
                <!--  -->

                <!--  -->
                <span>{{ `${item.name}_XXXXX` }}</span>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <input type="text" placeholder="Prefix ..." v-model="item.name" class="flex-shrink border border-black flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none" />
            <!--  -->
            
            <!--  -->
            <div class="flex -mr-px justify-center p-1">
              <!--  -->
              <input type="text" placeholder="Country name ..." v-model="item.countryName" class="flex border border-black items-center leading-normal flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none" />
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
        {{ $t('packages') }}
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label for="authorized_open_package" class="block uppercase text-gray-700 text-xs font-bold mb-2">{{
              $t('authorized_open_package') }}
            </label>
            <!--  -->

            <!--  -->
            <label for="toogleA" class="flex items-center cursor-pointer">
              <!--  -->
              <div class="relative">
                <!--  -->
                <input id="toogleA" v-model="formData.detailSeller.open_colis" type="checkbox" class="hidden" />
                <!--  -->

                <!--  -->
                <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                <!--  -->

                <!--  -->
                <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="ml-3 text-gray-700">
                {{ formData.detailSeller.open_colis }}
              </div>
              <!--  -->
            </label>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
      
      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400" />
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 mb-10 text-sm mt-3 font-bold uppercase">
        Services
      </h6>
      <!--  -->

      <!--  -->
      <div class="flex flex-col lg:flex-row">
        <!--  -->
        <div class="intro-y flex-1 box py-4 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.confirmation }">
          <!--  -->
          <div class="check">
            <!--  -->
            <span class="feather-icon select-none relative">
              <!--  -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
                <!--  -->
                <polyline points="20 6 9 17 4 12" />
                <!--  -->
              </svg>
              <!--  -->
            </span>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto">
            <!--  -->
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <!--  -->

            <!--  -->
            <line x1="3" y1="6" x2="21" y2="6" />
            <!--  -->

            <!--  -->
            <path d="M16 10a4 4 0 0 1-8 0" />
            <!--  -->
          </svg>
          <!--  -->

          <!--  -->
          <div class="text-xl font-medium text-center mt-1">Confirmation</div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="intro-y flex-1 box py-4 lg:ml-5 mb-5 lg:mb-0 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.fulfillement }">
          <!--  -->
          <div class="check">
            <!--  -->
            <span class="feather-icon select-none relative">
              <!--  -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
                <!--  -->
                <polyline points="20 6 9 17 4 12" />
                <!--  -->
              </svg>
              <!--  -->
            </span>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto">
            <!--  -->
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <!--  -->

            <!--  -->
            <line x1="3" y1="6" x2="21" y2="6" />
            <!--  -->

            <!--  -->
            <path d="M16 10a4 4 0 0 1-8 0" />
            <!--  -->
          </svg>
          <!--  -->

          <!--  -->
          <div class="text-xl font-medium text-center mt-1">Warehouse</div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="intro-y flex-1 box py-4 lg:ml-5 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.shipping }">
          <!--  -->
          <div class="check">
            <!--  -->
            <span class="feather-icon select-none relative">
              <!--  -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
                <!--  -->
                <polyline points="20 6 9 17 4 12" />
                <!--  -->
              </svg>
              <!--  -->
            </span>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto">
            <!--  -->
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <!--  -->

            <!--  -->
            <line x1="3" y1="6" x2="21" y2="6" />
            <!--  -->

            <!--  -->
            <path d="M16 10a4 4 0 0 1-8 0" />
            <!--  -->
          </svg>
          <!--  -->

          <!--  -->
          <div class="text-xl font-medium text-center mt-1">Shipping</div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      formData: {
        details: [],
        dataUser: [],
        detailSeller: {
          open_colis: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
        },
        detail: {
          shipping: {
            fees: 0,
          },
          order: {
            feesConfirmation: 0,
            fulfillement_fees: 0
          },
          global_fees: 0,
          quality_control: 0,
          tva: 0,
          phone: null,
        },
        tva: [],
      },
      detail: {
        shipping: {
          fees: 0,
        },
        order: {
          feesConfirmation: 0,
          fulfillement_fees: 0
        },
        global_fees: 0,
        quality_control: 0,
        tva: 0,
        phone: null,
      },
      detailSeller: {
        open_colis: false,
        confirmation: false,
        fulfillement: false,
        shipping: false,
      },
      loading: false,
      fullPage: false,
      tvaInput: '',
      idWharhouse: null,
      currency: '',
      options: this.$countries,
      cities: [],
      coutryW: '',
      currentUser: {
        role: {},
      },
      activeAllFees: false,
      newCity: {
        cityName: '',
        cityFees: 0
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    async warhouseSelected() {
      await this.getwharhouseId();
      await this.getCurrency();
      await this.getSettings();
      await this.getCities();
    },
  },
  async mounted() {
    await this.getUser();
    await this.getwharhouseId();

    await this.getCurrency();
    await this.getSettings();
    
    await this.getCities();
    this.onGlobalFeesChange();
  },
  methods: {
    addCity() {
      if (!this.newCity.cityName || this.newCity.cityFees <= 0) {
        alert('Please enter valid city details.');
        return;
      }
      this.formData.detail.cities.push({
        ...this.newCity,
        display: false
      });
      this.newCity.cityName = '';
      this.newCity.cityFees = 0;
    },
    removeCity(index) {
      this.formData.detail.cities.splice(index, 1);
    },
    onGlobalFeesChange() {
      const globalFeesValue = parseFloat(this.formData.detail.global_fees);

      if (globalFeesValue == 0) {
        this.activeAllFees = true;
      } else if (!isNaN(globalFeesValue) && globalFeesValue > 0) {
        this.activeAllFees = false;
      }
    },
    trigger() {
      this.$refs.sendReply.click();
    },
    Show(index, show) {
      this.cities[index].display = !show;
    },
    copyIt(id) {
      document.getElementById(id).removeAttribute('disabled');
      const copyInput = document.querySelector(`#${id}`);

      copyInput.select();
      document.execCommand('copy');
      document.getElementById(id).setAttribute('disabled', true);
    },
    async getUser() {
      const res = await this.$server.me('users');
      // 
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getCities() {
      const resCities = await this.$server.get('zones', {
        allCitiesAndFees: true,
        country: await this.warhouseSelected,
      });
      if (resCities.content.length > 0 && (await this.warhouseSelected)) {
        this.cities = resCities.content;
        this.cities = this.cities.map(v => ({ ...v, display: false }));

      } else {
        this.cities = [];
      }
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },
    async getElementInArray(data, value) {
      const result = data.filter(o => {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar === value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    addTva() {
      if (
        this.tvaInput === '' ||
        this.tvaInput === null ||
        this.tvaInput.value === 0
      ) {
        alert('Please enter tva in text box below !! ', 'warning');
      } else if (isNaN(this.tvaInput)) {
        alert('Please enter a number value', 'warning');
      } else {
        this.formData.tva.push(this.tvaInput);
        this.tvaInput = '';

      }
    },
    deleteTva(index) {
      this.formData.tva.splice(index, 1);
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    async changeData(data, warhouse, element) {
      for (const i in data) {
        if (data[i].warehouse === warhouse.toString()) {
          data[i] = element;
          break; // Stop this loop, we found it!
        }
      }
    },
    async save() {
      // get data current warhouse
      if (this.currentUser.type !== 'Seller') {
        const dataWahrhouse = await this.$server.get('settings', {
          warehouse: this.idWharhouse._id,
        });
        if (dataWahrhouse.content.length > 0) this.formData.action = 'Update';
        else this.formData.action = 'Add';

        this.formData.detail.warehouse = this.idWharhouse._id;
        const data = await this.$server.update('settings', this.formData);
        if (data._id) {
          await this.getSettings();
          alert(this.$t('setting_updated'), 'success');
        }
      } else {
        const userData = await this.$server.get('users', {
          id: this.currentUser._id,
        });
        this.formData.dataUser = userData.content;
        const dataWahrhouse = await this.$server.get('users', {
          id: this.currentUser._id,
          warehouseSettings: this.idWharhouse._id,
        });
        if (dataWahrhouse.content.length > 0) {
          this.changeData(
            this.formData.dataUser.settings,
            this.idWharhouse._id,
            this.formData.detailSeller,
          );
        } else {
          this.formData.detailSeller.warehouse = this.idWharhouse._id;
          this.formData.dataUser.settings.push(this.formData.detailSeller);
        }

        const data = await this.$server.update('users', {
          _id: this.currentUser._id,
          settings: this.formData.dataUser.settings,
          prefixs: this.currentUser.prefixs.filter(
            x => x.name || x.countryName,
          ),
        });
        if (data && data._id) {
          await this.getSettings();
          alert(this.$t('setting_updated'), 'success');
        }
      }
    },
    async getSettings() {
      this.loading = true;
      this.coutryW = await this.warhouseSelected;

      const data = await this.$server.get('settings');
      const dataWahrhouse = await this.$server.get('settings', {
        warehouse: this.idWharhouse._id,
      });

      this.formData.tva = data.content.tva;
      this.formData._id = data.content._id;
      this.formData.details = data.content.details;

      if (dataWahrhouse.content.length > 0) {
        const currentSettingW = await this.getElementInArray(
          dataWahrhouse.content[0].details,
          this.idWharhouse._id,
        );
        this.formData.detail = currentSettingW;
      } else {
        this.formData.detail = {
          shipping: { fees: 0 },
          order: { 
            feesConfirmation: 0,
            fulfillement_fees: 0
          },
          global_fees: 0,
          quality_control: 0,
          tva: 0,
          phone: null,
        };
      }

      if (this.currentUser.type === 'Seller') {
        const dataWahrhouse = await this.$server.get('users', {
          id: this.currentUser._id,
          warehouseSettings: this.idWharhouse._id,
        });

        if (dataWahrhouse.content.length > 0) {
          const currentSettingW = await this.getElementInArray(
            dataWahrhouse.content[0].settings,
            this.idWharhouse._id,
          );
          this.formData.detailSeller = currentSettingW;
        } else {
          this.formData.detailSeller = {
            open_colis: false,
            confirmation: false,
            fulfillement: false,
            shipping: false,
          };
        }

        if (!this.currentUser.prefixs) this.currentUser.prefixs = [];
        this.currentUser.countries.forEach(arg => {
          var index = this.currentUser.prefixs.findIndex(
            x => x.country === arg,
          );
          if (index === -1)
            this.currentUser.prefixs.push({
              name: '',
              countryName: '',
              country: arg,
            });
        });

      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.tag-rail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}

.rail-container {
  overflow: hidden;
  height: 36px;
  padding-top: 6px;
  cursor: pointer;
  scroll-behavior: smooth;
}

.tag {
  background: #e3ebf7;
  border-radius: 8px;
  padding: 3px 8px 4px;
  margin: 5px 4px;
  color: #285192;
  font-weight: 500;
  user-select: none;
  border: 1px solid #e3ebf7;
  transition-duration: 0.25s;
  white-space: nowrap;
  border: 2px dashed #013179;
}

.tag:first-child {
  margin-left: 16px;
}

.tag:last-child {
  margin-right: 16px;
}

.tag:hover {
  background: #dce4f0;
}

.tag:active {
  background: #e3ebf7;
}

.tag-selected {
  background: #3b71ca;
  color: #fff;
  border: 1px solid #3b71ca;
}

.tag-selected:hover {
  background: #3265b9;
  color: #fff;
}

.tag-selected:active {
  background: #3b71ca;
  color: #fff;
}

.btn-left-con,
.btn-right-con {
  position: absolute;
}

.btn-right-con {
  right: 0;
}

.btn-left,
.btn-right {
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 100%;
  cursor: pointer;
  transition-duration: 0.25s;
  box-shadow: 0 0 16px 24px #fff;
  background: #fff;
}

.btn-left {
  margin-left: 2px;
}

.btn-right {
  margin-right: 2px;
}

.btn-left:hover,
.btn-right:hover {
  background: #f2f2f2;
}

.btn-left:active,
.btn-right:active {
  background: #d9d9d9;
}

.d-none {
  display: none;
}

.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked~.toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.hori-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vs-chip--close {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  margin-left: 8px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  transition: all 0.3s ease;
}

.vs-chip--close:after {
  content: 'x';
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.max-height-200 {
  max-height: 200px;
}

.max-height-300 {
  max-height: 300px;
}

.accordion .accordion-item {
  border-bottom: 1px solid #2b9a5f;
}

.accordion button {
  position: relative;
  display: block;
  text-align: left;
  width: 100%;
  padding: 15px 0;
  color: #2b9a5f;
  font-size: 1.15rem;
  font-weight: 600;
  border: none;
  background: none;
  outline: none;
}

.accordion button:hover,
.accordion button:focus {
  cursor: pointer;
  color: #0d4c2a;
}

.accordion button .accordion-title {
  padding: 1em 1.5em 1em 0;
  text-transform: capitalize;
}

.accordion button .icon {
  display: inline-block;
  position: absolute;
  top: 18px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid;
  border-radius: 22px;
}

.accordion button .icon::before {
  display: block;
  position: absolute;
  content: '';
  top: 9px;
  left: 5px;
  width: 10px;
  height: 2px;
  background: currentColor;
}

.accordion button .icon::after {
  display: block;
  position: absolute;
  content: '';
  top: 5px;
  left: 9px;
  width: 2px;
  height: 10px;
  background: currentColor;
}

.accordion button[aria-expanded='true'] .icon::after {
  width: 0;
}

.tags-block {
  display: inline-block;
  padding: 0 10px;
  margin: 5px;
  background-color: #f0f0f0;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  text-shadow: 1px 1px #fff;
  font-size: 13px;
  float: left;
}
</style>
